import React from 'react'
import { SaveCancelButtons } from '@ztechapps/webui.button'
import { useContext } from './Context'

export const ApplyCancelButtons = ({ toggleShowModal }) => {
  const { onFilter, activeTemplate } = useContext()

  const onSave = async () => {
    await onFilter?.({ template: activeTemplate })
    toggleShowModal?.()
  }
  const onCancel = () => {
    toggleShowModal?.()
  }
  return (
    <SaveCancelButtons saveText="Apply Filter" saveBusyText="Applying filter..." onSave={onSave} onCancel={onCancel} />
  )
}
